import Layout from "../components/Layout";
import { PushSettings } from "../pwa/PushSettings";
import { InstallPrompt } from "../pwa/InstallPrompt";
import { useAuth } from "../lib/auth";
import { useI18n } from "../lib/i18n";

export default function SettingsNotifications() {
  const { user } = useAuth();
  const { lang, t } = useI18n();
  return (
    <Layout title={t("Meldingen")} subtitle={t("Pushmeldingen op dit apparaat — per type aan of uit")}>
      <div className="max-w-xl space-y-6" data-testid="settings-notifications">
        <InstallPrompt userId={user?.id} />
        <PushSettings lang={lang} />
      </div>
    </Layout>
  );
}
